import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../styles/DiverSafety.css';

const DiverSafety = () => {
  const [activeIndex, setActiveIndex] = useState(null); // FIXED: Declare state
const [hoverIndex, setHoverIndex] = useState(null); // ✅ Track hover
  const isMobile = window.innerWidth <= 600;

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const questions = [
    {
      question: "As a Driver, how do I identify my rider?",
      answer:
        "On the ride screen, you will be able to see your rider’s name and profile picture. When you see your rider at the pickup location, please confirm their name and profile picture before proceeding.",
    },
    {
      question: "How do I rate a rider?",
      answer:
        "After each completed ride, you will have the option to rate the rider. Ratings help us provide a great experience for both riders and drivers.",
    },
  ];

  return (
    <>
     <div className="safety-page">
  <section className="safety-header">
    <h1>
      Berymo runs on safety to protect
      <br /> our community
    </h1>
  </section>
</div>


     <div class="diver-container">
  <h2>From pickup to dropoff,we are there for you</h2>
  <p class="diver-subtext">
    Berymo Driver app offers unmatched privacy and security  We want to ensure .<br />
   that our drivers feel as comfortable navigating through the map as the riders<br />
     feel riding in your car.
  </p>


        <div className="diver-grid">
          {[
            {
              img: "history",
              title: "Ride history",
              text: "All completed rides are recorded and saved in your Berymo Drivers app. Details of all rides are kept in your history for your own records",
            },
            {
              img: "3",
              title: "Top tier support",
              text: "Berymo provides top tier support whenever you need it. We are here to help when you need it most, at all times of the day",
            },
            {
              img: "headphone",
              title: "Emergency calling",
              text: "If you are involved in an emergency, tap the Emergency button found on your driver app or call 911.",
            },
            {
              img: "phone",
              title: "Call privacy",
              text: "When using the Berymo driver call function, we hide both you and your rider's phone number for privacy purposes.",
            },
            {
              img: "star",
              title: "Rider ratings",
              text: "We value your feedback. At the end of each completed ride, you will have the option to rate your rider.",
            },
            {
              img: "schedule",
              title: "On your Schedule",
              text: "Drive with Berymo and earn extra income wherever you are and whenever you want to drive. Earn on your own schedule without a boss.",
            },
          ].map((item, i) => (
            <div className="diver-box" key={i}>
              <img
                src={`/images/${item.img}.png`}
                alt={item.img}
                className="icon"
              />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="divers-image">
        <img src="/images/driver-safety-general.jpg" alt="diver" />
      </div>



      {/* FAQ SECTION */}
<div
  style={{
    padding: isMobile ? "40px 15px" : "60px 0",
    backgroundColor: "#fff",
    fontFamily: "Helvetica, Arial, sans-serif",
  }}
>
  <h1
    style={{
      fontSize: isMobile ? "24px" : "26px",
      fontWeight: "bold",
      marginBottom: isMobile ? "25px" : "40px",
      textAlign: "left",
      color: "#000",
      lineHeight: isMobile ? "28px" : "32px",
      maxWidth: "1000px",
      margin: isMobile ? "0 auto" : "0 auto 40px",
    }}
  >
    {isMobile ? (
      <>
        Frequently asked
        <br />
        questions from our
        <br />
        rider
      </>
    ) : (
      "Frequently asked questions from our rider"
    )}
  </h1>

  <div
    style={{
      maxWidth: isMobile ? "100%" : "1000px",
      margin: "0 auto",
    }}
  >
    {questions.map((item, index) => (
      <div
        key={index}
        onClick={() => toggleQuestion(index)}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={() => setHoverIndex(null)}
        style={{
          borderBottom: "1px solid #e0e0e0",
          padding: isMobile ? "18px 0" : "22px 0",
          cursor: "pointer",
        }}
      >
        {/* Question Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontSize: isMobile ? "16px" : "18px",
              fontWeight: "bold",
              color:
                activeIndex === index || hoverIndex === index
                  ? "#FD5C63"
                  : "#000",
              lineHeight: "22px",
              width: "90%",
            }}
          >
            {item.question}
          </span>

          <span
            style={{
              fontSize: isMobile ? "22px" : "24px",
              fontWeight: "bold", 
              color:
                activeIndex === index || hoverIndex === index
                  ? "#FD5C63"
                  : "#000",
            }}
          >
            {activeIndex === index ? "×" : "+"}
          </span>
        </div>

        {/* Answer */}
        <div
          style={{
            maxHeight: activeIndex === index ? "400px" : "0px",
            opacity: activeIndex === index ? 1 : 0,
            overflow: "hidden",
            transition: "max-height 0.4s ease, opacity 0.3s ease",
            fontSize: isMobile ? "14px" : "16px",
            lineHeight: "22px",
            color: "#444",
            paddingTop: activeIndex === index ? "10px" : "0px",
            textAlign: "left",
          }}
        >
          {item.answer}
        </div>
      </div>
    ))}
  </div>
</div>

 <div
    style={{
        backgroundColor: "#FEF4F5",
        clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0% 100%)",
        padding: isMobile ? "120px 20px 20px" : "120px 20px 50px",
        textAlign: "center",
    }}
>
    <h1
        style={{
            fontSize: isMobile ? "20px" : "25px",
            marginBottom: isMobile ? "10px" : "17px",
            fontWeight: 700,
            lineHeight: isMobile ? "30px" : "42px",
            color: "#000",
        }}
    >
       Earn great money on your schedule
    </h1>

    <p
        style={{
            fontSize: isMobile ? "14px" : "16px",
            color: "#555",
            lineHeight: isMobile ? "22px" : "26px",
            margin: 0,
        }}
    >
        Drive with Berymo and earn up to $1,800 for the first 60 loops you complete in your city
    </p>

    {/* 👇 Wrap button in <a> to navigate */}
    <a
        href="https://play.google.com/store/apps/details?id=com.berymodriver"
        style={{ textDecoration: "none" }} // Remove underline
    >
        <button
            style={{
                backgroundColor: "#fd5c63",
                color: "#fff",
                border: "none",
                padding: isMobile ? "0.8rem 1.6rem" : "1rem 2.5rem",
                width: isMobile ? "42%" : "200px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: isMobile ? "0.7rem" : "0.69rem",
                textTransform: "uppercase",
                textAlign: "center",
                fontFamily: "'Segoe UI', Arial, sans-serif",
                borderRadius: "5px",
                transition: "background-color 0.3s ease, transform 0.2s ease",
                marginTop: isMobile ? "24px" : "30px",
                marginBottom: isMobile ? "40px" : "60px",
            }}
            onMouseOver={(e) => {
                e.target.style.backgroundColor = "#474747";
                e.target.style.transform = "translateY(-2px)";
            }}
            onMouseOut={(e) => {
                e.target.style.backgroundColor = "#fd5c63";
                e.target.style.transform = "scaleX(1)";
            }}
        >
            SIGN UP TO drive
        </button>
    </a>
</div>
     
    </>
  );
};

export default DiverSafety;

